<!-- Screenshot list-item card. Click body to annotate; explicit icon buttons for each action. -->
<div
  class="ss-card"
  [class.ss-card-selected]="selected"
  [class.ss-card-current-page]="onCurrentPage"
  role="button"
  tabindex="0"
  [attr.aria-label]="screenshot.caption || 'Screenshot ' + screenshot.id"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
>
  <!-- Optional select checkbox -->
  <ng-container *ngIf="selectMode">
    <mat-checkbox
      class="ss-card-checkbox bidone-checkbox"
      [checked]="selected"
      (change)="selectToggle.emit(screenshot)"
      (click)="$event.stopPropagation()"
      aria-label="Select screenshot"
    ></mat-checkbox>
  </ng-container>

  <!-- Thumbnail with badges -->
  <div class="ss-card-thumb">
    <img
      [src]="screenshot.thumbnail"
      [alt]="screenshot.caption || 'Screenshot'"
    />
    <span
      *ngIf="annotationCount > 0"
      class="ss-card-badge ss-card-badge-annot"
      [matTooltip]="annotationCount + ' annotation(s)'"
      matTooltipPosition="above"
    >
      <mat-icon>edit_note</mat-icon>
      <span class="ss-card-badge-count">{{ annotationCount }}</span>
    </span>
    <span
      *ngIf="shareCount > 0"
      class="ss-card-badge ss-card-badge-share"
      [matTooltip]="shareCount + ' share(s)'"
      matTooltipPosition="above"
    >
      <mat-icon>share</mat-icon>
      <span class="ss-card-badge-count">{{ shareCount }}</span>
    </span>
  </div>

  <!-- Content column -->
  <div class="ss-card-body">
    <p class="ss-card-caption" [title]="screenshot.caption">
      {{ screenshot.caption || "Untitled clip" }}
    </p>
    <div class="ss-card-meta">
      <app-profile-avatar
        *ngIf="screenshot.authorName"
        class="ss-card-author"
        [fullName]="screenshot.authorName"
        widthSize="20px"
        heightSize="20px"
      ></app-profile-avatar>
      <span class="ss-card-dims">{{ dimsLabel }}</span>
      <span class="ss-card-meta-sep">·</span>
      <span class="ss-card-age">{{ ageLabel }}</span>
    </div>
    <div class="ss-card-tags" *ngIf="screenshot.linkedMeasurementName">
      <span
        class="ss-card-tag-link"
        [style.--ss-tag-color]="screenshot.linkedMeasurementColor || '#3B82F6'"
        [matTooltip]="'Linked to ' + screenshot.linkedMeasurementName"
      >
        <span class="ss-card-tag-dot" aria-hidden="true"></span>
        {{ screenshot.linkedMeasurementName }}
      </span>
    </div>
  </div>

  <!-- Action icon-buttons -->
  <div class="ss-card-actions" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="ss-card-action ss-card-action-locate"
      [class.ss-card-action-locate--active]="isLocating"
      [matTooltip]="isLocating ? 'Hide location' : 'Locate snapshot'"
      [attr.aria-label]="isLocating ? 'Hide location' : 'Locate snapshot'"
      [attr.aria-pressed]="isLocating"
      (click)="onLocate($event)"
    >
      <mat-icon>my_location</mat-icon>
    </button>
    <button
      type="button"
      class="ss-card-action ss-card-action-share"
      matTooltip="Share"
      aria-label="Share screenshot"
      (click)="onShare($event)"
    >
      <mat-icon>share</mat-icon>
    </button>
    <button
      type="button"
      class="ss-card-action ss-card-action-annotate"
      matTooltip="Annotate"
      aria-label="Annotate screenshot"
      (click)="onAnnotate($event)"
    >
      <mat-icon>edit</mat-icon>
    </button>
    <button
      type="button"
      class="ss-card-action ss-card-action-delete"
      matTooltip="Delete"
      aria-label="Delete screenshot"
      (click)="onDelete($event)"
    >
      <mat-icon>delete</mat-icon>
    </button>
    <button
      type="button"
      class="ss-card-action ss-card-action-copy"
      matTooltip="Copy image"
      aria-label="Copy screenshot to clipboard"
      (click)="onCopy($event)"
    >
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
</div>
